PJQ.views.rfq.RFQResponseModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-rfq-response'),
        maxWidth: 600,
        isShowCloseButton: true,
        onSubmit: _.noop()
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-submit': 'submitResponse',
        'click .impact-response>button': 'impactResponseChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.options.isAdmin = this.options.project.hasPermission('changeRequests.isAdmin');

        this.hasChanged = false;
        this.response = {
            hasCostImpact: this.options.hasCostImpact ?? this.model.get('hasCostImpact'),
            amount: this.model.get('amount') ?? null,
            comment: this.model.get('comment') ?? null
        };
        this.attachments = this.model.responseAttachments.clone();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            model: this.model,
            response: this.response,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched || !this.response.hasCostImpact)
            return;

        new PJQ.Binder(this.$el, this.response, {
            watchElements: [
                'input'
            ],
            afterChange: () => {
                this.hasChanged = true;
            }
        });

        new PJQ.views.files.FileUploaderGrid({
            el: this.$('.rfq-response-file-uploader'),
            collection: this.attachments,
            useApiV2: true,
            canDelete: this.options.isAdmin,
            onSuccess: (file) => {
                this.hasChanged = true;
            },
            onDelete: (attachment, callback) => {
                this.hasChanged = true;

                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                callback();
            }
        });

        let self = this;
        this.$('.impact-response>button').each(function () {
            if ($(this).data('value') === self.response.hasCostImpact) {
                $(this).removeClass('inactive').addClass('font-weight-normal');
            } else {
                $(this).addClass('inactive').removeClass('font-weight-normal');
            }
        });

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);
    },
    impactResponseChanged: function (e) {
        this.response.hasCostImpact = $(e.currentTarget).data('value');
        this.render();
    },
    validate: function () {
        let err = null;
        if (this.response.hasCostImpact == null) {
            err = 'Please select a response';
        }

        this.$('.error-outer').html(err);

        return err == null;
    },
    submitResponse: function () {
        if (!this.validate()) {
            return;
        }

        if(!this.response.hasCostImpact){
            this.response.amount = null;
            this.response.comment = null;
        }

        this.options.onSubmit({
            response: this.response,
            attachments: this.attachments
        })
        this.removeModal();
    },
    close: function () {
        new PJQ.views.modals.YesNo({
            header: "Cancel Response?",
            body: "Are you sure you want to cancel your response?",
            onYes: () => {
                this.removeModal();
            }
        });
    }
});